export function isPositiveInteger(val) {
    let str = String(val);
    str = str.trim();
    if (!str) {
        return false;
    }
    str = str.replace(/^0+/, "") || "0";
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
}

export function isNumber(val) {
    let str = String(val);
    str = str.trim();
    if (!str) {
        return false;
    }
    return !isNaN(str) && !str.includes(',');
}